import React from 'react'
import { Link } from 'react-router-dom';
import { listarTiposTramites } from '../tramites/TipoTramiteService';
import BreadCrumComponent from '../componentes/BreadCrumComponent';
import { codigoFormularioAdelanto, codigoFormularioReposoMedico, codigoFormularioVacaciones } from '../../constans/constants';
import subir_archivo from '../../assets/images/icons/subir_archivo.svg';
import grupos from '../../assets/images/icons/grupos.svg';
import carpeta_zip from '../../assets/images/icons/carpeta_zip.svg';
import reposo_medico from '../../assets/images/icons/servicios_medicos.svg';
import adelanto_salarial from '../../assets/images/icons/bolsa_dinero.svg';
import vacaciones_icon from '../../assets/images/icons/sombrilla_playa.svg';


class NuevoLote extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tipoImportacion: '',
            tiposFormularios: null,
            loading: true
        };
    }

    async componentDidMount() {
        const tipoImportacion = this.getTipoImportacion(this.props.location.pathname);

        if (tipoImportacion === 'tramite') {
            
            localStorage.removeItem("formularioSeleccionado")

            try {
                const res = await listarTiposTramites();
                if (!res.error) {
                    this.setState({
                        tipoImportacion,
                        tiposFormularios: res.datos,
                        loading: false
                    });
                } else {
                    this.setState({ tipoImportacion, tiposFormularios: [], loading: false });
                }
            } catch (error) {
                console.error("Error al cargar tipos de formularios:", error);
                this.setState({ tipoImportacion, tiposFormularios: [], loading: false });
            }
        } else {
            this.setState({ tipoImportacion, loading: false });
        }
    }

    getTipoImportacion = (pathname) => {
        if (pathname.includes('/tramites/')) return 'tramite';
        if (pathname.includes('/lotes/')) return 'lote';
        return '';
    }

    guardarFormularioSeleccionado = (elemento) =>{
        localStorage.setItem("formularioSeleccionado", JSON.stringify(elemento));
    }

    render() {
        const { tipoImportacion, tiposFormularios, loading } = this.state;
        const esLote = tipoImportacion === 'lote';

        if (loading) {
            return <div className="page-container">Cargando...</div>;
        }

        return (
            
            <div className="template-base">
                <header className="component-header">
                    <div className="page-container">
                        <BreadCrumComponent
                            backUrl={esLote ? "/lote/nuevos" : "/bandeja/pendientes"}
                            breadcrumbs={esLote ? [{ label: 'Nuevo Lote', path: '' }] : [{ label: 'Nueva Solicitud', path: '' }]}
                        />
                        <div className="head-area">
                            <div className="caption-area">
                                <h1 className="page-title">{esLote ? "Generar nuevo lote" : "Iniciar solicitud"}</h1>
                                <p className="page-description">{esLote ? "Seleccione una acción para generar un nuevo lote" : "Seleccione el tipo de solicitud que desea realizar"}</p>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="wrapperContent">
                    <div className="page-container">
                        {esLote ? (
                            <div className="cards-grid">
                                <Link to="/lotes/generar/zip" className="card-link card">
                                    <div className="type-info">
                                        <div className="icon-shape shape-xl">
                                            <span className="material-symbols-outlined"> <img src={carpeta_zip} alt="subir_archivo_zip" /> </span>
                                        </div>
                                    </div>
                                    <div className="card-info">
                                        <h3 className="card-title-xl shape-xl"> Importar Lote desde Zip </h3>
                                        <p className="card-description"> Importar desde archivo zip previamente elaborado, estos pueden ser en formato xml o pdf </p>
                                    </div>
                                </Link>

                                <Link to="/lotes/generar/documento" className="card-link card">
                                    <div className="type-info">
                                        <div className="icon-shape shape-xl">
                                            <span className="material-symbols-outlined"> <img src={subir_archivo} alt="subir_archivo" /> </span>
                                        </div>
                                    </div>
                                    <div className="card-info">
                                        <h3 className="card-title-xl shape-xl"> Importar Documento </h3>
                                        <p className="card-description"> Importa un documento y asígnalo a un colaborador o lista de colaboradores seleccionadas manualmente </p>
                                    </div>
                                </Link>

                                <Link to="/lotes/generar/documento-grupos" className="card-link card">
                                    <div className="type-info">
                                        <div className="icon-shape shape-xl">
                                            <span className="material-symbols-outlined"> <img src={grupos} alt="enviar_a_grupos" /> </span>
                                        </div>
                                    </div>
                                    <div className="card-info">
                                        <h3 className="card-title-xl shape-xl"> Importar Documento a Grupo </h3>
                                        <p className="card-description"> Importa un documento y asígnalo a un grupo de colaboradores seleccionadas manualmente </p>
                                    </div>
                                </Link>
                            </div>
                        ) : (
                            <div className="cards-grid">
                                {tiposFormularios.map((elemento) => {
                                    switch (elemento.codigoFormulario) {
                                        case codigoFormularioVacaciones:
                                            
                                            return (
                                                <Link to={{ pathname: "/tramites/nuevo"}} style={{ pointerEvents: "auto", zIndex: 1000 }}
                                                    onClick={()=> this.guardarFormularioSeleccionado(elemento)} className="card-link card">
                                                    <div className="type-info">
                                                        <div className="icon-shape shape-xl">
                                                            <span className="material-symbols-outlined">
                                                                <img src={vacaciones_icon} alt="solicitud_vacaciones" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="card-info">
                                                        <h3 className="card-title-xl shape-xl">{elemento.nombre}</h3>
                                                        <p className="card-description">Licencia por vacaciones anuales</p>
                                                    </div>
                                                </Link>
                                            );
                                        case codigoFormularioReposoMedico:
                                           
                                            return (
                                                <Link to={{ pathname: "/tramites/nuevo"}} style={{ pointerEvents: "auto", zIndex: 1000 }}
                                                    onClick={()=> this.guardarFormularioSeleccionado(elemento)} className="card-link card">
                                                    <div className="type-info">
                                                        <div className="icon-shape shape-xl">
                                                            <span className="material-symbols-outlined">
                                                                <img src={reposo_medico} alt="solicitud_reposo_medico" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="card-info">
                                                        <h3 className="card-title-xl shape-xl">{elemento.nombre}</h3>
                                                        <p className="card-description">Licencia por indisposición o enfermedad</p>
                                                    </div>
                                                </Link>
                                            );
                                        case codigoFormularioAdelanto:
                                        
                                            return (
                                                <Link to={{ pathname: "/tramites/nuevo"}} style={{ pointerEvents: "auto", zIndex: 1000 }}
                                                    onClick={()=> this.guardarFormularioSeleccionado(elemento)} className="card-link card">
                                                    <div className="type-info">
                                                        <div className="icon-shape shape-xl">
                                                            <span className="material-symbols-outlined">
                                                                <img src={adelanto_salarial} alt="adelanto_salarial" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="card-info">
                                                        <h3 className="card-title-xl shape-xl">{elemento.nombre}</h3>
                                                        <p className="card-description">Solicitud de adelanto salarial</p>
                                                    </div>
                                                </Link>
                                            );
                                        default:
                                            return null;
                                    }
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

}

export default NuevoLote
